import React, { useState } from 'react';
import './App.css';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProductsSection } from './components/ProductsSection';
import { DeliverySection } from './components/DeliverySection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';

function App() {
  const [language, setLanguage] = useState('gu'); // Default to Gujarati

  return (
    <div className="App">
      <Header language={language} setLanguage={setLanguage} />
      <HeroSection language={language} />
      <ProductsSection language={language} />
      <DeliverySection language={language} />
      <ContactSection language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;